(function () {
  document.addEventListener("DOMContentLoaded", function () {
    let currentColorTheme = localStorage.getItem(COLOR_THEME) || COLOR_THEME_CURRENT;
    const navbar = document.querySelector(NAVBAR);
    const switchButtons = document.querySelectorAll(".js-switchButton");

    switchButtons.forEach(function (button) {
      const buttonText = button.querySelector(".js-switchButton-text");

      updateButton(button, buttonText);

      button.addEventListener("click", function () {
        handleClick(button, buttonText);
      });
    });

    function updateButton(button, text) {
      if (currentColorTheme && currentColorTheme === THEME_DARK) {
        button.classList.add("is-active");
        text.textContent = "Basculer en mode clair";
      } else {
        button.classList.remove("is-active");
        text.textContent = "Basculer en mode sombre";
      }
    }

    function handleClick(button, text) {
      // document.body.classList.toggle(CLASS_THEME_DARK);

      currentColorTheme = currentColorTheme && currentColorTheme === THEME_DARK ? THEME_LIGHT : THEME_DARK;

      document.body.classList[currentColorTheme === THEME_DARK ? "add" : "remove"](CLASS_THEME_DARK);
      document.body.classList[currentColorTheme === THEME_LIGHT ? "add" : "remove"](CLASS_THEME_LIGHT);

      localStorage.setItem(COLOR_THEME, currentColorTheme);

      updateButton(button, text);

      navbar.classList[currentColorTheme === THEME_DARK ? "add" : "remove"]("is-darkmode");

      navbar.style.setProperty("--menu-bgc", currentColorTheme === THEME_DARK ? COLOR_THEME_DARK : COLOR_THEME_LIGHT);

      (function ($) {
        if (typeof $.cookie == "function") {
          try {
            $.cookie(COLOR_THEME, currentColorTheme, {
              expires: 28,
              path: "/", // ;SameSite=Lax
              // domain: location.host,
              // secure: location.protocol.search("s") > -1,
            });
          } catch (error) {
            console.error(error);
          }
        }
      })(jQuery);
    }
  });
})();
